module.exports = __webpack_public_path__ + "img/sjk1.910b1599.png";